
import './App.css';
import './style/Global.css';
import Nav from './parts/Nav';
import Home from './pages/Home';
import Footer from './parts/Footer';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
//import Buy from './pages/Buy'
//import Faq from './pages/Faq'
//import Explore from './pages/Explore';
function App() {
  return (
    <Router>
    <div className="App">
      <Nav />
      <Switch>

    
        
        <Route path="/" component={(props) => <Home />} />
      </Switch>
      <Footer />
    </div>
    </Router>
  );
}

export default App;
